<template>
    <div>
        <button v-if="!loading" type="button" @click="showDescriptionModal" class="btn btn-icon">
            <i class="fas fa-info"></i>
        </button>
        <span v-else class="spinner-border spinner-border-sm"></span>

        <button v-if="row.status === bankTransferTransaction.UNKNOWN_YET" @click="showStatusModal" type="button" class="mx-4 btn btn-icon">
            <i class="fa fa-sync"></i>
        </button>
        <div class="tooltip-wrapper">
            <button
                v-show="row.status === bankTransferTransaction.PENDING"
                @click="cancelWithdraw"
                id="cancelWithdrawBTN"
                type="button"
                class="mx-4 btn btn-icon"
                :disabled="isCancelWithdrawBTNDisabled"
            >
      <span v-if="!isCancelWithdrawBTNDisabled">
        <i class="fa fa-window-close"></i>
      </span>
                <span v-else class="spinner-border spinner-border-sm"></span>
            </button>
            <span class="tooltip-text">{{ $t('label.cancel_withdraw') }}</span>
        </div>

        <!-- Status Change Modal -->
        <div v-if="showChangeStatusModal" id="change_status_modal" class="modal fade show d-block" tabindex="-1"
             role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ $t('open_banking.change_transfer_tr_status') }}</h4>
                        <h4 style="padding-right: 10px" class="modal-title">{{ selectedTransaction }}</h4>
                        <button @click="closeStatusModal" type="button" class="close float-right mr-0"
                                data-dismiss="modal">&times;
                        </button>
                    </div>
                    <div class="modal-body mb-4">
                        <!-- New status change form -->
                        <div class="mt-4">
                            <div class="form-group">
                                <label for="statusSelect">{{ $t('open_banking.new_status') }}</label>
                                <select
                                    id="statusSelect"
                                    class="form-control"
                                    v-model="selectedStatus"
                                >
                                    <option selected></option>
                                    <option :value="bankTransferTransaction.SUCCESS">
                                        {{ bankTransferTransactionStr.get(bankTransferTransaction.SUCCESS) }}
                                    </option>
                                    <option :value="bankTransferTransaction.FAILED">
                                        {{ bankTransferTransactionStr.get(bankTransferTransaction.FAILED) }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label for="statusReason">{{ $t('label.description') }}</label>
                                <textarea
                                    id="statusReason"
                                    class="form-control"
                                    v-model="statusChangeReason"
                                    rows="3"
                                ></textarea>
                            </div>

                            <button
                                @click="confirmStatusChange"
                                class="btn btn-primary float-md-none"
                                :disabled="!selectedStatus || statusChanging"
                            >
                                <span v-if="statusChanging" class="spinner-border spinner-border-sm"></span>
                                <span v-else>{{ $t('btn.edit') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Description Modal -->
        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="tx_title">
                        </div>
                        <div id="tx_log" class="ml-1">
                        </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">
                                    {{ $t('label.detail_money_request_form') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody id="description_details_body">
                            <!-- Description details will be populated here -->
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";
import {bankTransferTransaction, bankTransferTransactionStr} from "@/constants/bankTransferTransaction";
import {openBankingService} from "@/common/api.service";
import {
    openBankingRequestsStatus,
    financialServices,
    authenticationServices,
    inquiryServices
} from '@/constants/openBanking'
import {bankIdStr} from "../../../../constants/bankId";

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    data() {
        return {
            data: {},
            loading: false,
            isError: false,
            openBankingRequestsStatus,
            financialServices,
            authenticationServices,
            inquiryServices,
            bankTransferTransaction,
            selectedStatus: null,
            statusChangeReason: '',
            bankTransferTransactionStr,
            statusChanging: false,
            showChangeStatusModal: false,
            isCancelWithdrawBTNDisabled : false,
            selectedTransaction: null
        }
    },
    methods: {
        showDescriptionModal() {
            if (this.isError)
                return;
            let tr_body = $('#description_details_body').empty();
            $("#description_modal").modal('show')
            let tx_title = $('#tx_title').empty()
            let tx_log = $('#tx_log').empty()

            $("#description_modal").modal('show')

            let ps_elements = '<h4 class="modal-title float-left p-0 m-0">' + i18n.t('label.transaction_description')+ ' ' + this.row.id + '</h4>'
            tx_title.append(ps_elements)
            if (this.row.log_url) {
                let  ps_elements = '<a href="' + this.row.log_url + '" target="_blank" class="btn btn-sm btn-clean btn-icon btn-icon-sm"><i class="fa fa-history"></i></a>'
                tx_log.append(ps_elements)
            }
            tr_body.append(
                ' <tr><th>' + i18n.t('application.title') + '</th><th><a :href="`/applications/${row.description.application_id}/details`">' + this.row.description.application_title + '</a></th></tr>' +
                ' <tr><th>' + i18n.t('transaction_transfer.destination_full_name') + '</th><th>' + this.row.description.destination_full_name + '</th></tr>' +
                ' <tr><th>' + i18n.t('transaction_transfer.origin_full_name') + '</th><th>' + this.row.description.origin_full_name + '</th></tr>' +
                ' <tr><th>' + i18n.t('transaction_transfer.destination_account') + '</th><th>' + this.row.destination_account + '</th></tr>' +
                ' <tr><th>' + i18n.t('transaction_transfer.origin_account') + '</th><th>' + this.row.origin_account + '</th></tr>' +
                ' <tr><th>' + i18n.t('label.bank') + '</th><th>' + this.bankIdStr.get(this.row.description.bank) + '</th></tr>'+
                ' <tr><th>' + i18n.t('open_banking.wallet_balance_before_request') + '</th><th>' + this.moneyFormat(this.row.wallet_balance_before_request) + '</th></tr>'+
                ' <tr><th>' + i18n.t('open_banking.wallet_balance_after_request') + '</th><th>' + this.moneyFormat(this.row.wallet_balance_after_request) + '</th></tr>'+
                ' <tr><th>' + i18n.t('application.company_wage') + '</th><th>' + this.moneyFormat(this.row.company_wage) + '</th></tr>'+
                ' <tr><th>' + i18n.t('application.provider_wage') + '</th><th>' + this.moneyFormat(this.row.provider_wage) + '</th></tr>'+
                ' <tr><th>' + i18n.t('application.company_tax') + '</th><th>' + this.moneyFormat(this.row.company_tax)+ '</th></tr>'+
                ' <tr><th>' + i18n.t('application.provider_tax') + '</th><th>' + this.moneyFormat(this.row.provider_tax) + '</th></tr>')

            if (this.row.pay_id) {
                tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.pay_id') + '</th><th>' + this.row.pay_id + '</th></tr>');
            }
            if (this.row.reason) {
                tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.reason') + '</th><th>' + this.row.reason + '</th></tr>');
            }
            if (this.row.type) {
                tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.type') + '</th><th>' + this.row.type + '</th></tr>');
            }
            if (this.row.transfer_type) {
                tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.transfer_type') + '</th><th>' + this.row.transfer_type + '</th></tr>');
            }
            if (this.row.transaction_type) {
                tr_body.append(' <tr><th>' + i18n.t('open_banking.transaction_type') + '</th><th>' + this.row.transaction_type + '</th></tr>');
            }
            if (this.row.status === bankTransferTransaction.FAILED && this.row.description.fail_reason) {
                tr_body.append(' <tr><th>' + i18n.t('label.response_rejection_reason') + '</th><th>' + this.row.description.fail_reason + '</th></tr>');
            }
            if (this.row.detected_by === 0) {
                tr_body.append(' <tr><th>' + i18n.t('open_banking.detected_type') + '</th><th>' + i18n.t('open_banking.detected_automatically') + '</th></tr>');
            } else if (this.row.detected_by) {
                if (this.row.description.change_status_description) {
                    tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.change_status_description') + '</th><th>' + this.row.description.change_status_description + '</th></tr>');
                }
                tr_body.append(' <tr><th>' + i18n.t('open_banking.detected_by') + '</th><th><a href="/users/' + this.row.detected_by.id + '/details" target="_blank">' + this.row.detected_by.name + '</a></th></tr>');
            }
            if (this.row.status ===  bankTransferTransaction.REVERSAL && this.row.description.reversal_date) {
                tr_body.append(' <tr><th>' + i18n.t('transaction_transfer.reversal_date') + '</th><th>' +this.row.description.reversal_date + '</th></tr>');
            }
        },
        closeStatusModal() {
            this.showChangeStatusModal = false
        },
        showStatusModal() {
            this.selectedTransaction = null;
            this.selectedStatus = null;
            this.statusChangeReason = null;

            let tr_body = $('#change_status_details_body').empty();
            this.selectedTransaction = this.row.id
            tr_body.append(
                ' <tr><th>وضعیت فعلی</th><th>' + this.bankTransferTransactionStr.get(this.row.status) + '</th></tr>'
            );

            this.showChangeStatusModal = true;
        },
        async confirmStatusChange() {
            if (!this.selectedStatus) {
                this.toastr.error('لطفاً وضعیت جدید را انتخاب کنید');
                return;
            }

            this.statusChanging = true;

            try {
                const response = await openBankingService.adminChangeTransactionStatus(this.row.id, {
                    new_status: this.selectedStatus,
                    description: this.statusChangeReason
                });

                this.toastr.success('وضعیت تراکنش با موفقیت تغییر یافت');
                this.datatable.reload();
                this.closeStatusModal();
            } catch (error) {
                this.toastr.error('خطا در تغییر وضعیت: ' + error.message);
            } finally {
                this.statusChanging = false;
            }
            // function simpleText(data, title) {
            //     return '<tr><td style="width: 155px;">' + title + '</td>' +
            //             '<td>' + data + '</td></tr>'
            // }
            //
            // function currencyText(data, title) {
            //     return '<tr><td style="width: 155px;">' + title + '</td>' +
            //             '<td>' + moneyFormat(data) + ' ' + i18n.t('currency.rial') + '</td></tr>'
            // }
            //
            // function moneyFormat(price) {
            //     if (!price) return 0;
            //     const pieces = parseFloat(price).toFixed(0).split("");
            //     let ii = pieces.length;
            //     while ((ii -= 3) > 0) {
            //         pieces.splice(ii, 0, ",");
            //     }
            //     return pieces.join("");
            // }
            //
            // let title = $('#title').empty()
            // let res = $('#res').empty()
            // let ps_elements =
            //         '<h4 class="modal-title float-left p-0 m-0">' + i18n.t('label.description') + ' ' + this.row.id + '</h4>'
            // title.append(ps_elements)
            //
            // let request_details = this.data
            // let request_details_body = $('#request_details_body').empty()
            //
            // let service_type = this.data.service_type
            // ps_elements = simpleText(i18n.t('application.services.'+service_type), i18n.t('open_banking.service_title'))
            // request_details_body.append(ps_elements)
            //
            // Object.keys(request_details.input_data).forEach(function (field) {
            //     let field_str = field
            //     if (field == 'national_id')
            //         field_str = i18n.t('label.national_code')
            //     else if (field == 'mobile_number')
            //         field_str = i18n.t('label.phone')
            //     else if (field == 'birth_date')
            //         field_str = i18n.t('label.birth_date')
            //     else if (field == 'card_number')
            //         field_str = i18n.t('label.card_number')
            //     ps_elements = simpleText(request_details.input_data[field], field_str)
            //     request_details_body.append(ps_elements)
            // });
            //
            // let request_ip = this.data.ip
            // ps_elements = simpleText(request_ip, i18n.t('open_banking.request_ip'))
            // request_details_body.append(ps_elements)
            //
            // if (this.data.status == this.openBankingRequestsStatus.SUCCESS) {
            //     let fee = this.data.fee
            //     ps_elements = currencyText(fee, i18n.t('open_banking.request_fee'))
            //     request_details_body.append(ps_elements)
            //
            //     let wallet_balance_before_request = this.data.wallet_balance_before_request
            //     ps_elements = currencyText(wallet_balance_before_request, i18n.t('open_banking.wallet_balance_before_request'))
            //     request_details_body.append(ps_elements)
            //
            //     let wallet_balance_after_request = this.data.wallet_balance_after_request
            //     ps_elements = currencyText(wallet_balance_after_request, i18n.t('open_banking.wallet_balance_after_request'))
            //     request_details_body.append(ps_elements)
            // }
            // if (this.data.service_type.toUpperCase() in this.authenticationServices) {
            //     if (this.data.status == this.openBankingRequestsStatus.FAILED)
            //         ps_elements = simpleText(this.data.result, i18n.t('open_banking.failed_reason'))
            //     else {
            //         let is_matched = ''
            //         if (this.data.result.is_matched)
            //             is_matched = i18n.t('open_banking.is_matched')
            //         else
            //             is_matched = i18n.t('open_banking.is_not_matched')
            //         ps_elements = simpleText(is_matched, i18n.t('open_banking.is_matched_title'))
            //     }
            // }
            // request_details_body.append(ps_elements)
        },
        moneyFormat(price) {
            if (!price) return 0;
            const pieces = parseFloat(price).toFixed(0).split("");
            let ii = pieces.length;
            while ((ii -= 3) > 0) {
                pieces.splice(ii, 0, ",");
            }
            return pieces.join("");
        },
        cancelWithdraw(){
            const result = confirm(i18n.t('application.message.cancel_withdraw_transaction_alert'));
            if (!result) return;

            this.isCancelWithdrawBTNDisabled = true;
            let service = this.$can('update', 'open-banking') ?
                openBankingService.adminCancelWithdrawTransaction :  openBankingService.cancelWithdrawTransaction;
            service(this.row.id).then(res => {
                this.toastr.success(res.data.message);
                this.row.status = this.bankTransferTransaction.CANCELED;
                this.datatable.reload();
            }).catch(({response}) => {
                    this.toastr.error(response.data.message);
            }).finally(() => {
                this.isCancelWithdrawBTNDisabled = false;
            })
        }
    },
    computed: {
        bankIdStr() {
            return bankIdStr
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    }
})
</script>
<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-backdrop {
    opacity: 0.5;
}
.tooltip-wrapper {
    position: relative;
    display: inline-block;
}

.tooltip-text {
    visibility: hidden;
    background-color: #333;
    color: #fff;
    font-size: 12px;
    text-align: center;
    padding: 5px 8px;
    border-radius: 4px;

    /* positioning */
    position: absolute;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;

    opacity: 0;
    transition: opacity 0.2s;
}

.tooltip-wrapper:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>
